module.exports = __webpack_public_path__ + "img/kova_no.154cfacc.png";